import { Spinner } from "@fluentui/react-components";

export function FullScreenSpinner() {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <Spinner />
    </div>
  );
}
